import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { loadPayerServices, loadPayment } from '../../../store/actions/my-bills.actions';
import { PaymentCommonService } from '../../../services/payment.common.service';
import { SessionService } from '../../../services/ssession.service';
import { calcTotalAmount } from '../pipes/total-amount.pipe';
import { SigIdPaymentComponentRead, SigIdPaymentRead } from '../../../services/sig-id.common.model';
import {
  selectPayerData,
  selectPayment,
  selectPaymentComponentByIdZap
} from '../../../store/selectors/my-bills.selectors';
import { SigidPayerServiceData } from '../../../openapi';
import { zip } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { calcItemTotalAmount } from '../pipes/item-total-amount.pipe';

@Component({
  selector: 'app-my-bills-pay',
  standalone: true,
  imports: [],
  template: `
    <div class="d-flex justify-content-center">
      Za chwilę nastąpi przekierowanie do płatności...
    </div>
  `
})
export class MyBillsPayComponent implements OnInit, OnDestroy {

  private route: ActivatedRoute = inject(ActivatedRoute);

  private identSigId: string = this.route.snapshot.params['identSigId'];

  private serviceCode: string = this.route.snapshot.params['serviceCode'];

  private idZap: string = this.route.snapshot.params['idZap'];

  private email: string = this.route.snapshot.queryParams['email'];

  private paymentCommonService: PaymentCommonService = inject(PaymentCommonService);

  private store$: Store = inject(Store);

  private sub = this.idZap ? zip([
    this.store$.select(selectPayment),
    this.store$.select(selectPayerData(this.identSigId)),
    this.store$.select(selectPaymentComponentByIdZap(this.idZap))
  ]).subscribe(([payment, payerData, paymentComponent]) => {
    if (paymentComponent && payerData && payment) {
      this.goToPay(payment, payerData, paymentComponent);
    }
  }) : zip([
    this.store$.select(selectPayment),
    this.store$.select(selectPayerData(this.identSigId))
  ]).subscribe(([payment, payerData]) => {
    if (payment && payerData) {
      this.goToPayForAll(payment, payerData);
    }
  });

  private goToPayForAll(payment: SigIdPaymentRead, payerData: SigidPayerServiceData): void {
    this.paymentCommonService.goToPay({
      returnUrl: `${environment.ssl ? 'https' : 'http'}://${window.location.host}/moje-oplaty/zaplac/status`,
      accountNumberOverride: payment?.service?.accountNumber || undefined,
      clientEmail: this.email || SessionService.GetTokenData()?.email || '',
      clientFirstName: SessionService?.GetTokenData()?.firstName || '',
      clientLastName: SessionService?.GetTokenData()?.lastName || '',
      descriptionOverride: `${payment?.service?.code || ''}, ${payerData?.fullName || ''} - ${this.identSigId}`,
      totalAmount: calcTotalAmount(payment?.components)
    }).subscribe();
  }

  private goToPay(payment: SigIdPaymentRead, payerData: SigidPayerServiceData, component: SigIdPaymentComponentRead): void {
    this.paymentCommonService.goToPay({
      returnUrl: `${environment.ssl ? 'https' : 'http'}://${window.location.host}/moje-oplaty/zaplac/status`,
      accountNumberOverride: payment?.service?.accountNumber || undefined,
      clientEmail: SessionService.GetTokenData()?.email || '',
      clientFirstName: SessionService?.GetTokenData()?.firstName || '',
      clientLastName: SessionService?.GetTokenData()?.lastName || '',
      descriptionOverride: `${payment?.service?.code || ''}, ${payerData?.fullName || ''} - ${this.identSigId}`,
      totalAmount: calcItemTotalAmount(component)
    }).subscribe();
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadPayment({
      identSigId: this.identSigId,
      serviceCode: this.serviceCode,
      idZap: this.idZap
    }));
    this.store$.dispatch(loadPayerServices({}));
  }

  public ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
